diy.angular.registerController('diyfmmain', ['$scope', 'diyfmsectionsdata', 'diyfminsertprogress', 'diyfmconfig', 'diyfmblocking', 'diyfmtracking', 
function($scope, diyfmsectionsdata, diyfminsertprogress, diyfmconfig, diyfmblocking, diyfmtracking) {

    $scope.sections = diyfmsectionsdata;
    
    $scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection){
        $scope.currentSubsection = newSubsection;
    });
    
    $scope.insertprogress = diyfminsertprogress;
    $scope.config = diyfmconfig;
    
    $scope.$on('uploadFiles.up', function(event, files, subsection, addToInsert, uploadSource){
        // we should broadcast a different event name
        // to not get back here
        $scope.$broadcast('uploadFiles.down', files, subsection, addToInsert, uploadSource);
    });
    
    $scope.diyfmblocking = diyfmblocking;

    $scope.dropFilesConfig = {
        eventName: 'uploadFiles.up',
        source: 'drag'
    };

}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/controllers/diyfmmain.js
 ** module id = 965
 ** module chunks = 0
 **/